import axios from "../utils/axios";
import { useEffect, useState } from "react";
import get from "lodash/get";
import { useLocation } from "react-router-dom";

export const GetHook = (url: string) => {
  const [data, setData] = useState<any>([]);
  const [pending, setPending] = useState(true);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [availableResultSet, setAvailableResultset] = useState(0)

  const location = useLocation();

  const reload = (idToReload?: string) => {
    const id = get(location, "key");
    if (idToReload === id) {
      setPending(true);
      setRefresh(!refresh);
    }
  };

  useEffect(() => {
    url !== "null" &&
      axios
        .get(url)
        .then((response) => {
          setPending(false);
          setData(get(response, "data.returned_resultset"));
          setAvailableResultset(get(response, 'data.available_resultset_size'))
        })
        .catch((err) => {
          setError(err.response);
          setPending(false);
        });
  }, [url, refresh]);
  return { data, pending, error, reload, availableResultSet };
};

export const DeleteHook = (url: string) => {
  const [data, setData] = useState<any>([]);
  const [pending, setPending] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    url !== "null" &&
      axios
        .delete(url)
        .then((response) => {
          setPending(false);
          setData(get(response, "data.returned_resultset"));
        })
        .catch((err) => {
          setError(err.response);
          setPending(false);
        });
  }, [url]);
  return { data, pending, error };
};

export const PostHook = (fn: any) => {
  const [res, setRes] = useState<any>({
    data: null,
    status: 0,
    complete: false,
    pending: false,
    error: false,
  });
  const [req, setReq] = useState<any>();

  useEffect(() => {
    if (!req) return;
    setRes({
      data: null,
      status: 0,
      pending: true,
      error: false,
      complete: false,
    });
    axios(req)
      .then((res) => {
        setRes({
          data: get(res, "data", null),
          status: get(res, "status", 0),
          pending: false,
          error: false,
          complete: true,
        });
      })
      .catch((err) => {
        const errRes = err.response;
        setRes({
          data: get(errRes, "data"),
          status: get(errRes, "status", 0),
          pending: false,
          error: true,
          complete: true,
        });
      });
  }, [req]);

  return [res, (...args: any) => setReq(fn(...args))];
};

export const postEndpoint = () => {
  return PostHook((url: string, data: any, config: any) => ({
    url: url,
    method: "POST",
    data,
    config,
  }));
};
export const putEndpoint = () => {
  return PostHook((url: string, data: any, config: any) => ({
    url: url,
    method: "PUT",
    data,
    config,
  }));
};
